import React, { useEffect, useMemo, useState } from "react";
import { Formik } from "formik";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { getDistributionNormalAll } from "../../_redux/normalCrud";
import ReactSelect, { components } from "react-select";
import { useHistory } from "react-router-dom";

export const DistributionNormalFilter = ({
  listLoading,
  currentData = {},
  setCurrentData,
  distributionData = {},
  setDistributionData,
}) => {
  // * QUOTA
  const applyFilter = (values) => {
    getDistributionNormalAll(values).then((res) => {
      const { total_quota, list_quota } = res.data;
      setCurrentData((prev) => ({
        ...prev,
        limit: total_quota,
      }));

      // ? SET TO ARRAY FILTER
      const area_uuids = [];
      const partner_uuids = [];

      list_quota.forEach((item) => {
        area_uuids.push(item.thk_area_uuid);
        partner_uuids.push(item.thk_partner_uuid);
      });

      // ? CALL FUNC FOR CURRENT OPTIONS
      if (!values.thk_area_uuid) getAreaOptions(area_uuids);
      if (!values.thk_partner_uuid) getPartnerOptions(partner_uuids);
    });
  };

  // * OPTIONS
  // ? INITIAL OPTIONS FIRST FETCH DATA
  const [initialOptions, setInitialOptions] = useState({
    // ? PARTNER FOR USER OPTIONS
    partner: [],
    area: [],
    livestock: [],
  });

  // ? CURRENT OPTIONS FOR USER OPTIONS, FILTER FROM INITAL OPTIONS
  const [currentOptions, setCurrentOptions] = useState({
    partner: [],
    area: [],
  });

  useEffect(() => {
    getDistributionNormalAll({ is_merging: false }).then((res) => {
      const {
        data: { list_area, list_livestock, list_partner },
      } = res;
      setInitialOptions({
        partner: list_partner,
        livestock: list_livestock,
        area: list_area,
      });
    });
  }, []);

  // * GET OPTIONS FROM ARRAY FILTER
  const getAreaOptions = (area_uuids) => {
    setCurrentOptions((prev) => {
      const tempArea = [...initialOptions.area];
      const getArea = tempArea.filter(({ uuid }) => area_uuids.includes(uuid));
      return {
        ...prev,
        area: getArea,
      };
    });
  };

  const getPartnerOptions = (partner_uuids) => {
    setCurrentOptions((prev) => {
      const tempPartner = [...initialOptions.partner];
      const getPartner = tempPartner.filter(({ uuid }) =>
        partner_uuids.includes(uuid)
      );
      return {
        ...prev,
        partner: getPartner,
      };
    });
  };

  const history = useHistory();

  //  ? REACT SELECT EXTRA COMPONENT
  const { MenuList, ValueContainer, SingleValue, Placeholder } = components;

  const CreateLivestockButton = ({ selectProps, ...props }) => {
    // Copied from source
    // const { onInputChange, inputValue, onMenuInputFocus } = selectProps;
    return (
      <div>
        <MenuList {...props} selectProps={selectProps} />
        <button
          style={{
            width: "100%",
          }}
          className="btn btn-secondary"
          onClick={() => {
            history.push("/kurban/campaign-hewan-kurban/new");
          }}
        >
          Tambah Hewan
        </button>
      </div>
    );
  };

  const CreateAreaButton = ({ selectProps, ...props }) => {
    // Copied from source
    return (
      <div>
        <MenuList {...props} selectProps={selectProps} />
        <button
          style={{
            width: "100%",
          }}
          className="btn btn-secondary"
          onClick={() => {
            history.push("/kurban/area/new");
          }}
        >
          Tambah Area
        </button>
      </div>
    );
  };

  const CreatePartnerButton = ({ selectProps, ...props }) => {
    // Copied from source
    return (
      <div>
        <MenuList {...props} selectProps={selectProps} />
        <button
          style={{
            width: "100%",
          }}
          className="btn btn-secondary"
          onClick={() => {
            history.push("/kurban/partner/new");
          }}
        >
          Tambah Mitra
        </button>
      </div>
    );
  };

  return (
    <Formik
      initialValues={{ is_merging: false }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({ values, handleSubmit, handleBlur, setFieldValue }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col">
              <label>Hewan</label>
              <ReactSelect
                name="thk_livestock_uuid"
                options={initialOptions.livestock.map((item) => ({
                  label: item.name,
                  value: item.uuid,
                }))}
                isClearable
                placeholder="Pilih Hewan"
                components={{ MenuList: CreateLivestockButton }}
                onChange={(e) => {
                  const value = e && e.value;
                  if (value) {
                    setFieldValue("thk_livestock_uuid", value);
                    setFieldValue("thk_area_uuid", null);
                    setFieldValue("thk_partner_uuid", null);
                    // ? FILTER DATA
                    setCurrentData((prev) => ({
                      ...prev,
                      thk_livestock_uuid: value,
                    }));
                    // ? DISTRIBUTION DATA
                    setDistributionData((prev) => ({
                      ...prev,
                      thk_livestock_uuid: value,
                      thk_area_uuid: "",
                      thk_partner_uuid: "",
                    }));
                    handleSubmit();
                  } else {
                    setFieldValue("thk_livestock_uuid", null);
                    setFieldValue("thk_area_uuid", null);
                    setFieldValue("thk_partner_uuid", null);
                    // ? FILTER DATA
                    setCurrentData((prev) => ({
                      ...prev,
                      thk_livestock_uuid: "",
                      limit: 0,
                    }));
                    // ? DISTRIBUTION DATA
                    setDistributionData((prev) => ({
                      ...prev,
                      thk_livestock_uuid: "",
                      thk_area_uuid: "",
                      thk_partner_uuid: "",
                    }));
                  }
                }}
                noOptionsMessage={({ inputValue }) => (
                  <>
                    <p>Hewan tidak ditemukan</p>
                  </>
                )}
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col-lg-5">
              <label>Wilayah</label>
              <ReactSelect
                name="thk_area_uuid"
                options={currentOptions.area.map((item) => ({
                  label: item.name,
                  value: item.uuid,
                }))}
                isClearable
                placeholder="Pilih Wilayah"
                components={{ MenuList: CreateAreaButton }}
                isDisabled={!distributionData.thk_livestock_uuid && true}
                value={
                  values.thk_area_uuid
                    ? {
                        label: values.thk_area_label,
                        value: values.thk_area_uuid,
                      }
                    : null
                }
                onChange={(e) => {
                  const value = e && e.value;
                  const label = e && e.label;
                  if (value) {
                    setFieldValue("thk_area_label", label);
                    setFieldValue("thk_area_uuid", value);
                    setFieldValue("thk_partner_uuid", null);
                    setDistributionData((prev) => ({
                      ...prev,
                      thk_area_uuid: value,
                      thk_partner_uuid: "",
                    }));
                    handleSubmit();
                  } else {
                    setFieldValue("thk_area_uuid", null);
                    setFieldValue("thk_area_label", null);
                    setFieldValue("thk_partner_uuid", null);
                    setDistributionData((prev) => ({
                      ...prev,
                      thk_area_uuid: "",
                      thk_partner_uuid: "",
                    }));
                    handleSubmit();
                  }
                }}
                noOptionsMessage={({ inputValue }) => (
                  <>
                    <p>Area tidak ditemukan</p>
                  </>
                )}
              />
            </div>
            <div className="col-lg-5">
              <label>Mitra</label>
              <ReactSelect
                name="thk_partner_uuid"
                options={currentOptions.partner.map((item) => ({
                  label: item.name,
                  value: item.uuid,
                }))}
                isClearable
                placeholder="Pilih Mitra"
                components={{ MenuList: CreatePartnerButton }}
                isDisabled={!distributionData.thk_area_uuid && true}
                value={
                  values.thk_partner_uuid
                    ? {
                        label: values.thk_partner_label,
                        value: values.thk_partner_uuid,
                      }
                    : null
                }
                onChange={(e) => {
                  const value = e && e.value;
                  const label = e && e.label;
                  if (value) {
                    setFieldValue("thk_partner_label", label);
                    setFieldValue("thk_partner_uuid", value);
                    setDistributionData((prev) => ({
                      ...prev,
                      thk_partner_uuid: value,
                    }));
                    handleSubmit();
                  } else {
                    setFieldValue("thk_partner_uuid", null);
                    setDistributionData((prev) => ({
                      ...prev,
                      thk_partner_uuid: "",
                    }));
                    handleSubmit();
                  }
                }}
                noOptionsMessage={({ inputValue }) => (
                  <>
                    <p>Mitra tidak ditemukan</p>
                  </>
                )}
              />
            </div>
            <div className="col-lg-2">
              <label>Stok Tersedia</label>
              <input
                className="form-control"
                value={currentData.limit}
                disabled
                readOnly
              />
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};
